// extracted by mini-css-extract-plugin
export default {"logoImage":"styles_logoImage__Pu2jw","title":"styles_title__8QEFU","line":"styles_line__YiKH2","resend":"styles_resend__Uvkdg","disabled":"styles_disabled__okuM0"};